import {
  useWSSnackbar,
  WSAlert,
  WSElement
} from "@wingspanhq/fe-component-library";
import { NotificationWithGroup } from "../../selectors/selectorAlerts";
import React, { useCallback, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import { useMutationDismissNotification } from "../../../../query/notifications/mutations/useMutationDismissNotification";
import { useMutationViewNotification } from "../../../../query/notifications/mutations/useMutationViewNotification";
import { useOnVisible } from "../../../../shared/hooks/useOnVisible";
import { notificationToAlert } from "./notificationToAlert";

type Props = {
  notification: NotificationWithGroup;
};

export const NotificationAlert: React.FC<Props> = props => {
  const history = useHistory();

  const { openSnackbar } = useWSSnackbar();
  const [dismissNotification] = useMutationDismissNotification({
    onError: () => {
      openSnackbar({
        type: "warning",
        duration: 3000,
        message: `Sorry, something went wrong`
      });
    }
  });

  const handleDismiss = useCallback(() => {
    dismissNotification(props.notification.channelMessageId);
  }, [dismissNotification, props.notification.channelMessageId]);

  const [readNotification] = useMutationViewNotification();

  const [isViewed, setIsViewed] = useState(props.notification.isViewed);
  const [ref] = useOnVisible(() => {
    setIsViewed(true);
    readNotification(props.notification.channelMessageId);
  }, isViewed);

  const alertProps = useMemo(
    () => notificationToAlert(props.notification, history),
    [history, props.notification]
  );

  return (
    <WSElement ref={ref}>
      <WSAlert {...alertProps} onDismiss={handleDismiss} />
    </WSElement>
  );
};
